import { ShortCode } from '@highereducation/wordpress';
import { ExpertByLine } from '@highereducation/hen-ui';

type ExpertByLineShortcodeProps = {
  name?: string;
  role?: string;
  'avatar-src'?: string;
  'avatar-fallback'?: string;
  href?: string;
  [key: string]: unknown;
};

/**
 * ExpertByLineShortcode - Shortcode wrapper for ExpertByLine (avatar, name, role, optional link).
 *
 * @example
 * [hen-ui-expert-by-line name="Dr. Jane Smith" role="Clinical Psychologist" avatar-src="https://example.com/photo.jpg" href="/profile" /]
 */
export const ExpertByLineShortcode: ShortCode<ExpertByLineShortcodeProps> = {
  component: ({
    name = '',
    role = '',
    'avatar-src': avatarSrc,
    'avatar-fallback': avatarFallback,
    href,
  }) => {
    if (!name || !role) return null;
    return (
      <ExpertByLine
        name={name}
        role={role}
        avatarSrc={avatarSrc}
        avatarFallback={avatarFallback}
        href={href}
      />
    );
  },
};
